<fieldset class="c-radio-list02" [ngClass]="{ 'is-error': errorMessage !== '' }" role="radiogroup" aria-invalid="false">
  <legend class="c-radio-list02__legend u-visually-hidden">{{ legend }}</legend>
  <div class="c-radio-list02__wrap">
    <div class="c-radio-list02__list">
      <div *ngFor="let item of text; index as i" class="c-radio-list02__item">
        <input
          type="radio"
          name="{{ id }}-{{ i }}-input-{{ item }}"
          id="{{ id }}-{{ i }}-input"
          class="c-radio-list02__item-input"
          [checked]="item.length !== 0 && item === selectedItem"
          (keydown)="keyDown($event, item)"
        />
        <label for="{{ id }}-{{ i }}-input" class="c-radio-list02__item-label" (click)="changeSelect(item)">
          <span id="{{ id }}-{{ i }}-input-text" class="c-radio-list02__item-text" [innerHTML]="item"></span>
        </label>
      </div>
    </div>
  </div>
</fieldset>
<ng-container *ngIf="errorMessage">
  <asw-validation-error [id]="id + 'error-message'" [errorMessage]="errorMessage"></asw-validation-error>
</ng-container>
